import { useVimUserMetadata } from '@getvim/internal-vim-os-sdk/react';
import { logger } from '@getvim/vim-connect-logger';
import { useEffect, useMemo } from 'react';
export const useEnrichLoggerMetadata = (): void => {
  const log = useMemo(() => logger.scope('[useEnrichLoggerMetadata]'), []);

  const { organization, ehrVendor, deviceId, user, userSessionId } = useVimUserMetadata();

  useEffect(() => {
    try {
      logger.setMetadata({
        deviceId: deviceId!,
        adapterName: ehrVendor,
        organizationId: organization?.identifiers?.id,
        organization_name: organization?.identifiers?.name,
        version: window?.$vim_environment?.version || '',
        windowId: '',
        ehrUserName: user?.identifiers?.ehrUsername,
      });
      logger.setUserMetadata({ userSessionId });
    } catch (error) {
      log.warning('Error setting logger metadata', { error: error, noPHI: true });
    }
  }, [organization, ehrVendor, deviceId, userSessionId, user?.identifiers?.ehrUsername, log]);
};
